import { Button } from '@/components'

export const AuthorizationErrorGeneracTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-25 rounded text-gray-700">
        <h4 className="font-semibold">For Generac Systems</h4>
        <p className="my-4">
            Your company successfully associated your PWRfleet account with Solar Insure at the company level,
            but we were unable to view details for this specific site. This most often occurs when a company
            forgets to share an individual site. You must share access with Solar Insure at the fleet and site
            level for data to appear on the Solar Insure platform.
        </p>
        <h5 className="font-semibold">
            Step One: Verify Manufacturer System ID Enrolled on the Warranty
        </h5>
        <ul className="mt-4 list-decimal pl-5">
            <li>Navigate to the "Warranty Holder Details - Warranty Tab".</li>
            <li>
                Click on the "Edit Warranty" option to access and modify the warranty enrollment details.
            </li>
            <li>
                Carefully verify that the Manufacturer System Identifier entered is correct.
                Cross-reference this ID with the site listed in your <a
                    href="https://pwrfleet.generac.com/login"
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary-700 underline"
                >PWRfleet portal.</a>
                <div>a. Navigate to the "All Sites" list to find the related system.</div>
                <div>b. Click on the system to open its details page.</div>
                <div>
                    c. The Site ID can be found in the URL of the site. It is the unique identifier after
                    /sites/ in the URL.
                </div>
            </li>
            <li>
                If the system ID does not match, update the ID on Solar Insure Daybreak Platform and save the
                changes.
            </li>
        </ul>
        <h5 className="font-semibold mt-4">Step Two: Associate an Individual Site with Solar Insure</h5>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                Log into the <a
                    href="https://pwrfleet.generac.com/login"
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary-700 underline"
                >PWRfleet portal.</a></li>
            <li>
                Navigate to the "All Sites" list to find the related system. Click on the system to
                open its details page.
            </li>
            <li>Click on the “Access” tab in the left sidebar.</li>
            <li>Select “Share Site”</li>
            <li>Select Solar Insure and click “Share”. </li>
            <li>
                Return to the Daybreak platform. Click on the refresh monitoring button to initiate a new
                attempt to pull monitoring data.
            </li>
        </ul>
        <Button
            design="btn-secondary"
            className="block text-center mt-4 w-fit"
            target="_blank"
            href="/resources/Generac_Fleet_&_Site_Level_Integrations.pdf"
        >
            Click here for a Visual Guide
        </Button>
    </div>
